import { Box, Stack, Typography } from '@mui/material';

import { ColorsRaw } from '@/ui/theme/colors-raw';
import { ColorsScore } from '@/ui/theme/colors-score';
import { Fonts } from '@/ui/theme/fonts';

export function ScoreText({
  value,
  text,
  variant = 'default',
  boxTextColor = ColorsScore.C.main,
  boxBackgroundColor = ColorsScore.C.secondary,
}: {
  value: string;
  text?: string;
  variant?: 'default' | 'box';
  boxTextColor?: string;
  boxBackgroundColor?: string;
}) {
  return (
    <Stack>
      {variant === 'default' ? (
        <ValueDefault value={value} />
      ) : (
        <ValueBox
          value={value}
          boxTextColor={boxTextColor}
          boxBackgroundColor={boxBackgroundColor}
        />
      )}
      <Typography
        sx={{
          fontSize: '1rem',
          fontWeight: 700,
          opacity: 0.7,
          color: ColorsRaw.basic.Cream,
        }}
      >
        {text}
      </Typography>
    </Stack>
  );
}

function ValueDefault({ value }: { value: string }) {
  return (
    <Typography
      sx={{
        fontSize: '1.5rem',
        fontWeight: 900,
        color: ColorsRaw.basic.White,
      }}
    >
      {value}
    </Typography>
  );
}

function ValueBox({
  value,
  boxBackgroundColor,
  boxTextColor,
}: {
  value: string;
  boxBackgroundColor: string;
  boxTextColor: string;
}) {
  return (
    <Box
      sx={{
        backgroundColor: boxBackgroundColor,
        paddingX: 1,
        borderRadius: 2,
      }}
    >
      <Typography
        sx={{
          fontSize: '1.25rem',
          fontWeight: 800,
          color: boxTextColor,
          fontFamily: Fonts.DarkerGrotesque,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}
